import type { PouchType } from "../types.js";

/**
 * Get a dieline category from a slug.
 *
 * @param pouchTypes The pouches to select from
 * @param slug The slug to get the category for.
 * @returns The category for the slug.
 */
export function getCategoryFromSlug(
	pouchTypes: PouchType[],
	slug: string | undefined,
): null | PouchType {
	return pouchTypes.find((c) => getCategorySlug(c) === slug) || null;
}

/**
 * Get the slug for a dieline category.
 *
 * @param category The category to get the slug for.
 * @returns The slug for the category.
 */
export function getCategorySlug(category: PouchType): string {
	return category.pouchType.toLowerCase().replace(/ /g, "-");
}
/**
 * Converts mm into prettified inches.
 *
 * @param mm The millimetres
 * @returns The inches to two decimal points.
 */
export function mmToInches(mm: number): string {
	return (mm / 25.4).toFixed(2);
}
